import React from 'react';
import CorporatePost from './posts/CorporatePost';
import Pagination from './Pagination';
import LoadMore from './LoadMore';
import useSettingsContext from '../context/useSettingsContext';
import useDataContext from '../context/useDataContext';
import useCore from '../methods/core/useCore';

function CorporatePosts() {
  const {paginationStyle, postType, postsPerRowParameter} = useSettingsContext();
  const {posts, postTypes, loading} = useDataContext();
  const {resetSelected} = useCore();
  const noResultsText = 'Sorry, no results.';
  const clearFiltersText = 'Clear Filters';

  let postItems;

  if (posts) {
    postItems = posts.map((post, index) => {
      return (
        <CorporatePost 
          key={index}
          post={post}
        ></CorporatePost>
      )
    });
  }

  const loadingClass = loading ? 'loading-active' : '';
  let postsContent;
  let paginationContent;

  if (paginationStyle === 'more') {
    paginationContent = <LoadMore></LoadMore>
  }

  else if (paginationStyle === 'pagination') {
    paginationContent = <Pagination></Pagination>
  }

  if (posts && posts.length > 0) {
    postsContent = <div>
      <div className={`eight29-posts corporate-posts ${loadingClass}`} style={postsPerRowParameter}>
        {postItems}
      </div>

      {paginationContent}
    </div>
  }

  else {
    if (!loading) {
      postsContent = <div className="no-results">
        {noResultsText}

        <div className="c-btn-wrapper">
          <button 
            className="c-btn c-btn-secondary c-btn-color-normal" 
            onClick={() => {resetSelected()}}
          >{clearFiltersText}</button>
        </div> 
      </div>
    }
  }

  return (
   <section className="eight29-posts-container corporate-posts-container">
      {postsContent}
   </section>
  );
}

export default CorporatePosts;

